import { render, staticRenderFns } from "./inspectrecord.vue?vue&type=template&id=a8e1c8e8&scoped=true"
import script from "./inspectrecord.vue?vue&type=script&lang=js"
export * from "./inspectrecord.vue?vue&type=script&lang=js"
import style0 from "./inspectrecord.vue?vue&type=style&index=0&id=a8e1c8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e1c8e8",
  null
  
)

export default component.exports